import React, { useState, useEffect } from "react";

export default function BrowserShop() {
  let [count, setCount] = useState(2);
  let [count1, setCount1] = useState(1);
  let [count2, setCount2] = useState(1);

  useEffect(() => {
    const setAnimationDelay = (elements, delayMultiplier) => {
      elements.forEach((element, index) => {
        element.style.animationDelay = `${index * delayMultiplier}s`;
      });
    };

    const listItems = document.querySelectorAll(".fadeIn");
    const productBoxes = document.querySelectorAll(".product-box");

    setAnimationDelay(listItems, 0.2);
    setAnimationDelay(productBoxes, 0.1);

    const handleButtonClick = () => {
      document.querySelector(".app-right").classList.add("isOpen");
      document.querySelector(".app-left").classList.add("hide");
    };

    const handleHideClick = () => {
      document.querySelector(".app-right").classList.remove("isOpen");
      document.querySelector(".app-left").classList.remove("hide");
    };

    document
      .querySelector(".action-button")
      .addEventListener("click", handleButtonClick);
    document
      .querySelector(".app-right-hide")
      .addEventListener("click", handleHideClick);
  }, []);

  return (
    <section className="app-container">
      <div className="app-left">
        <div className="app-header">
          <div className="app-filter-wrapper">
            <button className="filter-dropdown-button">
              <span>All Categories</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-chevron-down"
                viewBox="0 0 24 24"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>
            <input
              className="filter-search-input"
              type="text"
              placeholder="Search..."
            />
          </div>
           <button className="action-button active">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-shopping-bag"
            >
              <defs />
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0" />
            </svg>
          </button>
        </div>
        <div className="app-left-content">
          <div className="app-left-content-header">
            <h1 className="content-title">
              Discover <span>the best</span>
            </h1>
            <a href="#" className="content-link">
              See More
            </a>
          </div>
          <div className="app-content-field">
            <div className="product-box medium">
              <img
                className="product-box-image"
                src="https://images.unsplash.com/photo-1531471689044-dd3ca86632e1?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=2250&q=80"
                alt="Product"
              />
              <div className="product-box-details">
                Decoration <span>55</span>
              </div>
            </div>
            <div className="product-boxes">
              <div className="product-box-wrapper three">
                <div className="product-box medium">
                  <img
                    className="product-box-image"
                    src="https://images.unsplash.com/photo-1510877073473-6d4545e9c2af?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1234&q=80"
                    alt="Product"
                  />
                  <div className="product-box-details">
                    Tables <span>55</span>
                  </div>
                </div>
                <div className="product-box medium">
                  <img
                    className="product-box-image"
                    src="https://images.unsplash.com/photo-1519710164239-da123dc03ef4?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1234&q=80"
                    alt="Product"
                  />
                  <div className="product-box-details">
                    Lamps <span>45</span>
                  </div>
                </div>
                <div className="product-box medium">
                  <img
                    className="product-box-image"
                    src="https://images.unsplash.com/photo-1526827826797-7b05204a22ef?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1234&q=80"
                    alt="Product"
                  />
                  <div className="product-box-details">
                    Shelves <span>25</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="app-content-field second">
            <div className="product-box-wrapper three">
              <div className="product-box medium">
                <img
                  className="product-box-image"
                  src="https://images.unsplash.com/photo-1502920924215-5646fe685bef?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=2250&q=80"
                  alt="Product"
                />
                <div className="product-box-details">
                  Mirrors <span>35</span>
                </div>
              </div>
              <div className="product-box medium">
                <img
                  className="product-box-image"
                  src="https://images.unsplash.com/photo-1453904300235-0f2f60b15b5d?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1233&q=80"
                  alt="Product"
                />
                <div className="product-box-details">
                  Plants <span>25</span>
                </div>
              </div>
              <div className="product-box medium">
                <img
                  className="product-box-image"
                  src="https://images.unsplash.com/photo-1604014237256-11d475e2a2d8?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1234&q=80"
                  alt="Product"
                />
                <div className="product-box-details">
                  Bathroom <span>25</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="app-right">
        <button className="app-right-hide">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-x"
            viewBox="0 0 24 24"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
        <div className="app-right-content">
          <ul className="product-list">
            <li className="product-list-item fadeIn">
              <div className="product-img-wrapper">
                <img
                  className="product-image"
                  src="https://images.unsplash.com/photo-1544030288-e6e6108867f6?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTJ8fGZ1cm5pdHVyZXxlbnwwfDF8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=900&q=60"
                />
              </div>
              <div className="product-list-itemContent">
                <div className="product-info">
                  <h2 className="product-info-header">Monokai</h2>
                  <p className="product-info-subheader">
                    {125.0 * count} $
                    <span className="product-color">Yellow</span>
                  </p>
                </div>
                <div className="product-amount-wrapper">
                  <button
                    className="product-amount-button increase"
                    onClick={() => setCount(++count)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-chevron-up"
                      viewBox="0 0 24 24"
                    >
                      <path d="M18 15l-6-6-6 6" />
                    </svg>
                  </button>
                  <span className="product-amount">{count}</span>
                  <button
                    className="product-amount-button decrease"
                    onClick={() => count > 0 && setCount(--count)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-chevron-down"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                </div>
              </div>
            </li>
            <li className="product-list-item fadeIn">
              <div className="product-img-wrapper">
                <img
                  className="product-image"
                  src="https://images.unsplash.com/photo-1541533260371-b8fc9b596d84?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1234&q=80"
                  alt="product"
                />
              </div>
              <div className="product-list-itemContent">
                <div className="product-info">
                  <h2 className="product-info-header">Night Owl</h2>
                  <p className="product-info-subheader">
                    {225.0 * count1} $
                    <span className="product-color">Gray</span>
                  </p>
                </div>
                <div className="product-amount-wrapper">
                  <button
                    className="product-amount-button increase"
                    onClick={() => setCount1(++count1)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-chevron-up"
                      viewBox="0 0 24 24"
                    >
                      <path d="M18 15l-6-6-6 6" />
                    </svg>
                  </button>
                  <span className="product-amount">{count1}</span>
                  <button
                    className="product-amount-button decrease"
                    onClick={() => count1 > 0 && setCount1(--count1)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-chevron-down"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                </div>
              </div>
            </li>
            <li className="product-list-item fadeIn">
              <div className="product-img-wrapper">
                <img
                  className="product-image"
                  src="https://images.unsplash.com/photo-1506377295352-e3154d43ea9e?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1234&q=80"
                />
              </div>
              <div className="product-list-itemContent">
                <div className="product-info">
                  <h2 className="product-info-header">Material</h2>
                  <p className="product-info-subheader">
                    {105.0 * count2} $
                    <span className="product-color">Gray</span>
                  </p>
                </div>
                <div className="product-amount-wrapper">
                  <button
                    className="product-amount-button increase"
                    onClick={() => setCount2(++count2)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-chevron-up"
                      viewBox="0 0 24 24"
                    >
                      <path d="M18 15l-6-6-6 6" />
                    </svg>
                  </button>
                  <span className="product-amount">{count2}</span>
                  <button
                    className="product-amount-button decrease"
                    onClick={() => count2 > 0 && setCount2(--count2)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-chevron-down"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                </div>
              </div>
            </li>
          </ul>
          <div className="product-details fadeIn">
            <div className="product-details-line">
              <span className="product-details-text">Sub Total</span>
              <span className="product-details-text amount">
                {125 * count + 225 * count1 + 105 * count2} $
              </span>
            </div>
            <div className="product-details-line">
              <span className="product-details-text">Shipment</span>
              <a href="#" className="product-details-link">
                Check details
              </a>
              <span className="product-details-text amount">15.00 $</span>
            </div>
            <div className="product-details-line">
              <span className="product-details-text">Discount</span>
              <a href="#" className="product-details-link">
                Remove
              </a>
              <span className="product-details-text amount">-10.00 $</span>
            </div>
            <div className="product-details-summary">
              <span className="product-details-text">Total</span>
              <span className="product-details-text amount">
                {125 * count + 225 * count1 + 105 * count2 + 15 - 10} $
              </span>
            </div>
          </div>
        </div>
        <button className="checkout-button">Checkout Payment</button>
      </div>
    </section>
  );
}
